<template>
  <van-popup :value="visible" @input="$emit('update:visible', $event)" round style="width: 90%">
    <div class="shippingAddress">
      <div class="title">
        <span>收获地址</span>
      </div>
      <div class="content">
        <div class="row">
          <van-field v-model="addressData.real_name" label="收货人" placeholder="请输入收货人姓名" />
        </div>
        <div class="row">
          <van-field v-model="addressData.mobile" type="number" label="电话号码" placeholder="请输入收货人电话号码" />
        </div>
        <div class="row" @click="areaShow = true">
          <van-field v-model="addressData.area" label="所在地区" readonly placeholder="请选择省市区" />
        </div>
        <div class="row">
          <van-field v-model="addressData.address" type="textarea" label="详细地址" placeholder="输入详细地址" />
        </div>
      </div>
      <div class="btn-list">
        <van-button class="cancel" type="default" @click="$emit('update:visible', false)">取消</van-button>
        <van-button class="confirm" type="info" @click="onSubmit">确定</van-button>
      </div>
      <van-popup v-model="areaShow" round style="width: 100%">
        <div class="area">
          <van-area title="地区" :area-list="areaList" @confirm="onAreaConfirm" @cancel="onAreaCancel" @change="onAreaChange" />
        </div>
      </van-popup>
    </div>
  </van-popup>
</template>

<script>
import { areaList } from '@vant/area-data';
export default {
  props: {
    visible: { type: Boolean, default: false },
    product: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      addressData: {
        real_name: '',
        mobile: '',
        address: '',
        area: '',
        province: '',
        city: '',
        district: '',
      },
      areaShow: false,
      areaList,
    };
  },
  watch: {
    visible(val) {
      // 关闭时清空，避免下次重开残留
      if (val) this.areaShow = false;
    },
  },
  methods: {
    onAreaConfirm(e) {
      this.addressData.area = e[0].name + ' ' + e[1].name + ' ' + e[2].name;
      this.addressData.province = e[0].name;
      this.addressData.city = e[1].name;
      this.addressData.district = e[2].name;
      this.areaShow = false;
    },
    onAreaCancel() {
      this.areaShow = false;
    },
    onAreaChange() {},
    onSubmit() {
      const { real_name, mobile, area, address } = this.addressData;
      if (!real_name || !mobile || !area || !address) {
        this.$toast('请完整填写收获信息');
        return;
      }
      this.$emit('confirm', { addressData: { ...this.addressData }, product: this.product });
    },
  },
};
</script>

<style lang="less" scoped>
.shippingAddress {
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  background: #ffffff;

  .title {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    padding: 0 0 16px;
    border-bottom: 1px solid rgb(223, 239, 253);
  }

  .btn-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
    .confirm {
      color: #fff;
      background: #7938cf;
    }
    .cancel {
      color: #7938cf;
      border: 1px solid #7938cf;
      background: #fff;
    }
  }
}
.area {
  width: 100%;
  height: 380px;
  padding: 16px;
  border-radius: 6px;
  background: #ffffff;
}
/deep/ .van-field {
  background-color: #f3f9fe;
  border-radius: 8px;
  margin: 6px 0;
}
/deep/ .van-field__body {
  padding: 10px 10px 10px 0;
}
/deep/.van-field__label {
  padding: 10px 0 10px 10px;
}
input::-webkit-input-placeholder {
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
}
input:-moz-placeholder {
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
}
input::-moz-placeholder {
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
}
input:-ms-input-placeholder {
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
}
</style>
